import * as actionTypes from 'modules/mediaLibrary/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {boolean} MediaLibraryDrawerReducer  */

/** @type {MediaLibraryDrawerReducer} */
const initialState = false;

const open = () => true;
const close = () => initialState;

export default createReducer(initialState, {
  [actionTypes.OPEN_MEDIA_LIBRARY_DRAWER]: open,
  [actionTypes.CLOSE_MEDIA_LIBRARY_DRAWER]: close,
  [actionTypes.DELETE_MEDIA_LIBRARY_SUCCESS]: close,
  [actionTypes.UPDATE_MEDIA_LIBRARY_SUCCESS]: close,
});
